import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=58df6e7b&scoped=true"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"
import style0 from "./BasePagination.vue?vue&type=style&index=0&id=58df6e7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df6e7b",
  null
  
)

export default component.exports